import { useForm } from "react-hook-form"
import { enviarCorreo } from "../api/enviarCorreo";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isValidEmail } from "../resources/funciones";
import { useTranslation } from 'react-i18next'

const tema = "colored"

const notifyCorrecto = () => toast.success('Correo enviado 📧', {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: tema,
});

const notifyError = () => toast.error('Falló al enviar correo', {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: tema,
});

export const Contacto = () => {

  const { register, handleSubmit, formState: { errors }, reset } = useForm()
  const { t } = useTranslation()
  
  const BANNER_SRC = "/image/contacto/CONTACTBG.webp"

  const capitalize = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const handleEmailValidation = email => {
    const isValid = isValidEmail(email);
    return isValid;
  };

  const onSubmit = async (data) => {

    const mensajeCorreo = data.mensaje.replace("\n", " ")

    const dataPOST = {
      nombre: capitalize(data.nombre).trim(),
      apellido: capitalize(data.apellido).trim(),
      email: data.email,
      telefono: data.telefono.trim(),
      mensaje: mensajeCorreo.trim()
    }

    const { status } = await enviarCorreo(dataPOST)

    if (status === 1) {
      notifyCorrecto()
      reset()
    } else {
      notifyError()
    }
  }

  return (
    <div>
      <div className='hero-container hero-dark-gradient'>
        <img src={BANNER_SRC} alt="background" className='hero-bg'/>
        <div className="hero-content">
          <h1 className="text-center my-5" >{t("contacto_cabecera")}</h1>
          <div className="container">
            <div className="w-100 d-flex justify-content-center">
              <div className="col-12 col-lg-6">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-floating mb-3">
                          <input
                            {...register("nombre", { required: true })}
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            placeholder={t("contacto_input_nombre")}
                            style={{ textTransform: "uppercase" }} />
                          <label className="form-label">{t("contacto_input_nombre")}</label>
                        </div>
                        {errors.nombre && errors.nombre.type === "required" && <p role="alert" className="error">{t("contacto_msg_nombre_requerido")}</p>}
                      </div>
                      <div className="col-12 col-md-6 col-lg-6">
                        <div className="form-floating mb-3">
                          <input
                            {...register("apellido", { required: true })}
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            placeholder={t("contacto_input_apellido")}
                            style={{ textTransform: "uppercase" }} />
                          <label className="form-label">{t("contacto_input_apellido")}</label>
                        </div>
                        {errors.apellido && errors.apellido.type === "required" && <p role="alert" className="error">{t("contacto_msg_apellido_requerido")}</p>}
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="form-floating mb-3">
                          <input
                            {...register("email", { required: true, validate: handleEmailValidation })}
                            type="text"
                            className="form-control"
                            placeholder={t("contacto_input_correo")}
                          />
                          <label className="form-label">{t("contacto_input_correo")}</label>
                        </div>
                        {errors.email && errors.email.type === "required" && <p role="alert" className="error">{t("contacto_msg_correo_requerido")}</p>}
                        {errors.email && errors.email.type === "validate" && <p role="alert" className="error">{t("contacto_msg_correo_error")}</p>}
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="form-floating mb-3">
                          <input
                            {...register("telefono")}
                            type="text"
                            className="form-control mb-1"
                            autoComplete="off"
                            placeholder={t("contacto_input_telefono")}
                          />
                          <label className="form-label">{t("contacto_input_telefono")}</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <textarea
                            {...register("mensaje")}
                            className="form-control mb-1"
                            placeholder={t("contacto_text_mensaje")}
                            id="mensaje"
                            style={{height:"7rem"}}
                          />
                          <label htmlFor="mensaje" className="form-label">{t("contacto_text_mensaje")}</label>
                        </div>
                      </div>
                      <div className="col-12 mt-3 align-content-end">
                        <button type="submit" className="btn btn-primario w-100 text-white">{t("contacto_btn_enviar")}</button>
                      </div>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={tema}
      />
    </div>
  )
}